/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(function () {
	  (0, _module.toggleHeader)();
	  (0, _module.toggleBox)();
	  (0, _module.anchorLink)();
	  (0, _module.pageTop)();
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pageTop = exports.anchorLink = exports.toggleBox = exports.toggleHeader = void 0;
	
	// const breakPoint = 767;
	// let resizeFlag   = false;
	// let windowWidth  = window.innerWidth;
	// let windowHeight = window.innerHeight;
	// let windowWidthJ = $(window).width();
	// ------------------------------------------------------------------------
	// toggleHeader
	// ----- SP
	// ------------------------------------------------------------------------
	var toggleHeader = function toggleHeader() {
	  var headerFlag = false;
	  var stHeader = document.getElementById('st-Header');
	  var headerButtonOpen = document.getElementById('st-Header_Button_Open');
	  var headerNavigation = document.getElementById('st-Header_Navigation');
	  headerButtonOpen.addEventListener('click', function () {
	    if (!headerFlag) {
	      headerNavigation.classList.add('st-Header_Navigation-Open');
	      headerButtonOpen.classList.add('close');
	      stHeader.classList.add('st-Header-Hidden');
	      headerFlag = true;
	    } else {
	      headerNavigation.classList.remove('st-Header_Navigation-Open');
	      headerButtonOpen.classList.remove('close');
	      stHeader.classList.remove('st-Header-Hidden');
	      headerFlag = false;
	    }
	  }, false); // headerButtonClose.addEventListener('click', () => {
	  //   if(headerFlag){
	  //   }
	  // }, false);
	}; // ------------------------------------------------------------------------
	// toggleBox
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.toggleHeader = toggleHeader;
	
	var toggleBox = function toggleBox() {
	  var boxButton = document.getElementsByClassName('st-Box_Button');
	  var boxButtonText = document.getElementsByClassName('st-Box_Button_Text');
	  var boxContents = document.getElementsByClassName('st-Box_Contents');
	
	  var _loop = function _loop(i) {
	    boxButton[i].addEventListener('click', function () {
	      if (boxContents[i].classList.contains('st-Box_Contents-HiddenH') === true) {
	        boxButtonText[i].classList.remove('st-Box_Button_Text-Hidden');
	        boxContents[i].classList.remove('st-Box_Contents-HiddenH');
	        setTimeout(function () {
	          boxContents[i].classList.remove('st-Box_Contents-HiddenO');
	        }, 200);
	      } else {
	        boxButtonText[i].classList.add('st-Box_Button_Text-Hidden');
	        boxContents[i].classList.add('st-Box_Contents-HiddenO');
	        setTimeout(function () {
	          boxContents[i].classList.add('st-Box_Contents-HiddenH');
	        }, 200);
	      }
	    }, false);
	  };
	
	  for (var i = 0; i < boxButton.length; i++) {
	    _loop(i);
	  }
	}; // ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.toggleBox = toggleBox;
	
	var anchorLink = function anchorLink() {
	  //ページ外からのページ内リンク
	  var urlHash = location.hash;
	
	  if (urlHash) {
	    $('body,html').stop().scrollTop(0);
	    setTimeout(function () {
	      var target = $(urlHash);
	      var position = target.offset().top - 80;
	      $('body,html').stop().animate({
	        scrollTop: position
	      }, 500);
	    }, 200);
	  } //ページ内リンク
	
	
	  $("a[href^='#']").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 0;
	    var linkPosition = linkTarget.offset().top;
	    var windwW = $(window).width();
	
	    if (windwW >= 768) {
	      linkAdjust += 60;
	    } else {
	      linkAdjust += 80;
	    }
	
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "swing");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// pageTop
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.anchorLink = anchorLink;
	
	var pageTop = function pageTop() {
	  $("#st-footer_pagetop").on("click", function () {
	    var linkSpeed = 800;
	    console.log("AAA");
	    $("html, body").animate({
	      scrollTop: 0
	    }, linkSpeed, "swing");
	    return false;
	  });
	};
	
	exports.pageTop = pageTop;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// common.bundle.js